import ResizableScene from "../core/ResizableScene";
import GameColors from "../GameColors";
import Fonts from "../utils/Fonts";

export class PointsIndicator extends Phaser.GameObjects.Container {
	private readonly yMove = 80;

	emitters: Phaser.GameObjects.Particles.ParticleEmitter[] = [];

	constructor(scene: ResizableScene, x: number, y: number, points: number) {
		super(scene);
		this.setPosition(x, y);

		// offset points if it is to close to top of screen
		if (this.y < this.yMove) {
			this.y += Math.abs(this.y - (this.yMove + 50));
		}

		const rays = scene.add.image(0, 0, "scoreRays");
		this.add(rays);

		const particleContainer = scene.add.container(0, 0);
		this.add(particleContainer);
		//emitter
		//const emitters: Phaser.GameObjects.Particles.ParticleEmitter[] = [];

		for (let i = 0; i < 4; i++) {
			const particles = scene.add.particles("pointParticle" + Phaser.Math.RND.between(1, 2));
			particleContainer.add(particles);

			const emitter = particles.createEmitter({
				alpha: { start: 1, end: 0.0 },
				scale: { min: 0.7, max: 1.1 },
				frequency: 300,
				lifespan: 500,
				angle: Phaser.Math.RND.between(-360, 360),
				speedX: { min: -300, max: 300 },
				speedY: { min: -150, max: 150 },
			});
			this.emitters.push(emitter);
			emitter.start();
		}

		const text = scene.add.text(0, 0, "+" + points, {
			fontSize: "80px",
			color: GameColors.WHITE,
			fontFamily: Fonts.MontserratBold,
		});
		text.setOrigin(0.5, 0.5);
		this.add(text);

		scene.tweens.add({
			targets: rays,
			angle: 180,
			ease: Phaser.Math.Easing.Linear,
			duration: 2000,
		});

		this.scale = 0;
		scene.tweens.add({
			targets: this,
			scale: 1,
			ease: Phaser.Math.Easing.Back.Out,
			duration: 500,
		});

		scene.tweens.add({
			targets: this,
			alpha: 0,
			ease: Phaser.Math.Easing.Linear,
			delay: 400,
			duration: 1000,
			onComplete: () => this.destroy(),
		});

		scene.tweens.add({
			targets: this,
			y: this.y - this.yMove,
			ease: Phaser.Math.Easing.Linear,
			duration: 1400,
		});
	}

	static pauseEmitters(emitters: Phaser.GameObjects.Particles.ParticleEmitter[]): void {
		for (const emitter of emitters) {
			emitter.pause();
		}
	}

	static resumeEmitters(emitters: Phaser.GameObjects.Particles.ParticleEmitter[]): void {
		for (const emitter of emitters) {
			emitter.resume();
		}
	}
}
